export default __webpack_public_path__ + "static/media/myclassic3.38d9ac37.png";